export const constitucion_articulos = [
  '22 [[[Asociación]]]',
  '28.1 [[[Libertad sindical]]]',
  '23.2 [[[Acceso cargo público]]]',
  '47.1 [[[Derecho huelga]]]',
  '37.1 [[[Negociación colectiva]]]',
  '33 [[[Herencia y propiedad]]]',
  '53 [[[Defensor del pueblo]]]',
]